import { LoadingStatusType, PeakPayrollExceptionCode, TypeComponentNoti } from "@/enums/enums";
import {
  SetHeaderEmployeeHistoryTable,
  SetHeaderEmployeeTable,
  SetTapsEmployeeHistoryTable,
  SetTapsEmployeeTable,
  ToEmployeeFileModel,
  ToEmployeeModel,
  ToFileEmployeeContractModel,
  ToFileEmployeeIDCardModel,
  ValidateEmployeeTemplate,
} from "@/helper/employeeHelper";
import { GetExceptionsByExceptionCode } from "@/helper/exceptionCodeHelper";
import { i18n } from "@/i18n";
import { EmployeeDetailModel } from "@/model/employee/employeeDetailModel";
import { EmployeeFinanceChanelDetailModel } from "@/model/employee/employeeFinanceChanelDetailModel";
import { EmployeeModel } from "@/model/employee/employeeModel";
import { EmployeeStatementDetailModel } from "@/model/employee/employeeStatementDetailModel";
import { EmployeeTableHistoryViewModel } from "@/model/employee/employeeTableHistoryViewModel";
import { EmployeeTableViewModel } from "@/model/employee/employeeTableViewModel";
import { EmployeeTotalYearlyByEmployeeIdList } from "@/model/employee/employeeTotalYearlyByEmployeeIdList";
import { SalaryEmployeeTotalYearlyModel } from "@/model/employee/salaryEmployeeTotalYearlyModel";
import {
  ConverToEmloyeeList,
  ConvertToEmployeeDetail,
  ConvertToEmployeeFinanceChanelDetailList,
  ConvertToEmployeeHistoryTable,
  ConvertToEmployeeStatementDetailList,
  ConvertToEmployeeTable,
  ConvertToEmployeeTotalYearlyList,
} from "@/service/employee/employeeFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
@Module({ namespaced: true })
export default class Employee extends VuexModule {
  public employeeCreateId = 0;
  public createOrUpdateEmployeeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeList: Array<EmployeeModel> = [];
  public employeeSuggestionCodeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeSuggestionCode = "";
  public employeeTableLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeTableList: any = [];
  public headerEmployeeTable: any = [];
  public tapsEmployeeTable: any = [];
  public employeeDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeDetail: any = null;
  public employeeHistoryDetail: any = null;
  public deleteEmployeeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeFinanceChanelDetailList: Array<EmployeeFinanceChanelDetailModel> = [];
  public employeeFinanceChanelDetailListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeHistoryTableList: any = [];
  public headerEmployeeHistoryTable: any = [];
  public tapsEmployeeHistoryTable: any = [];
  public employeeStatementDetailList: Array<EmployeeStatementDetailModel> = [];
  public employeeStatementDetailListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeHistoryDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public emailOrBankAccountNumberDuplicated: any = null;
  public employeeTotalYearlyByEmployeeIdListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeTotalYearlyByEmployeeIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public employeeTotalYearlyList: Array<SalaryEmployeeTotalYearlyModel> = [];

  get getEmployeeCreateId(): number {
    return this.employeeCreateId;
  }
  get getCreateOrUpdateEmployeeLoadingStatus(): LoadingStatusType {
    return this.createOrUpdateEmployeeLoadingStatus;
  }
  get getEmployeeLoadingStatus(): LoadingStatusType {
    return this.employeeLoadingStatus;
  }
  get getEmployeeList(): Array<EmployeeModel> {
    return this.employeeList;
  }
  get getEmployeeTableLoadingStatus(): LoadingStatusType {
    return this.employeeTableLoadingStatus;
  }
  get getEmployeeTableList(): any {
    return this.employeeTableList;
  }
  get getHeaderEmployeeTable(): any {
    return this.headerEmployeeTable;
  }
  get getTapsEmployeeTable(): any {
    return this.tapsEmployeeTable;
  }
  get getEmployeeDetailLoadingStatus(): LoadingStatusType {
    return this.employeeDetailLoadingStatus;
  }
  get getEmployeeHistoryDetailLoadingStatus(): LoadingStatusType {
    return this.employeeHistoryDetailLoadingStatus;
  }
  get getEmployeeDetail(): EmployeeDetailModel {
    return this.employeeDetail;
  }
  get getEmployeeHistoryDetail(): any {
    return this.employeeHistoryDetail;
  }
  get getEmployeeHistoryTableList(): any {
    return this.employeeHistoryTableList;
  }
  get getHeaderEmployeeHistoryTable(): any {
    return this.headerEmployeeHistoryTable;
  }
  get getTapsEmployeeHistoryTable(): any {
    return this.tapsEmployeeHistoryTable;
  }
  get getEmployeeSuggestionCodeLoadingStatus(): LoadingStatusType {
    return this.employeeSuggestionCodeLoadingStatus;
  }
  get getEmployeeSuggestionCode(): string {
    return this.employeeSuggestionCode;
  }
  get getDeleteEmployeeLoadingStatus(): LoadingStatusType {
    return this.deleteEmployeeLoadingStatus;
  }
  get getEmployeeFinanceChanelDetailList(): Array<EmployeeFinanceChanelDetailModel> {
    return this.employeeFinanceChanelDetailList;
  }
  get getEmployeeFinanceChanelDetailListLoadingStatus(): LoadingStatusType {
    return this.employeeFinanceChanelDetailListLoadingStatus;
  }
  get getEmployeeStatementDetailList(): Array<EmployeeStatementDetailModel> {
    return this.employeeStatementDetailList;
  }
  get getEmployeeStatementDetailListLoadingStatus(): LoadingStatusType {
    return this.employeeStatementDetailListLoadingStatus;
  }
  get getEmailOrBankAccountNumberDuplicated(): any {
    return this.emailOrBankAccountNumberDuplicated;
  }
  get getEmployeeTotalYearlyByEmployeeIdLoadingStatus(): any {
    return this.employeeTotalYearlyByEmployeeIdLoadingStatus;
  }
  get getEmployeeTotalYearlyByEmployeeIdListLoadingStatus(): any {
    return this.employeeTotalYearlyByEmployeeIdListLoadingStatus;
  }
  get getEmployeeTotalYearlyList(): Array<SalaryEmployeeTotalYearlyModel> {
    return this.employeeTotalYearlyList;
  }

  @Mutation
  public MutationEmployeeCreate(employee: any) {
    this.employeeCreateId = employee ? employee.id : 0;
  }
  @Mutation
  public MutationCreateOrUpdateEmployeeLoadingStatus(status: LoadingStatusType) {
    this.createOrUpdateEmployeeLoadingStatus = status;
  }
  @Mutation
  public MutationEmployeeLoadingStatus(status: LoadingStatusType) {
    this.employeeLoadingStatus = status;
  }
  @Mutation
  public MutationEmployeeList(employeeList: Array<EmployeeModel>) {
    this.employeeList = employeeList;
  }
  @Mutation
  public MutationGetEmployeeTable(input: any) {
    this.tapsEmployeeTable = SetTapsEmployeeTable(input.table.count);
    this.headerEmployeeTable = SetHeaderEmployeeTable(input.tableViewModel);
    this.employeeTableList = input.table.tableList;
  }
  @Mutation
  public MutationEmployeeTableLoadingStatus(status: LoadingStatusType) {
    this.employeeTableLoadingStatus = status;
  }
  @Mutation
  public MutationEmployeeDetailLoadingStatus(status: LoadingStatusType) {
    this.employeeDetailLoadingStatus = status;
  }
  @Mutation
  public MutationEmployeeHistoryDetailLoadingStatus(status: LoadingStatusType) {
    this.employeeHistoryDetailLoadingStatus = status;
  }
  @Mutation
  public MutationEmployeeDetail(employeeDetail: any) {
    this.employeeDetail = employeeDetail;
  }
  @Mutation
  public MutationEmployeeHistoryDetail(input: any) {
    this.tapsEmployeeHistoryTable = SetTapsEmployeeHistoryTable(input.table.count);
    this.headerEmployeeHistoryTable = SetHeaderEmployeeHistoryTable(input.tableViewModel);
    this.employeeHistoryTableList = input.table.tableList;
  }
  @Mutation
  public MutationSetEmployeeSuggestionCodeLoadingStatus(loadingStatus: LoadingStatusType) {
    this.employeeSuggestionCodeLoadingStatus = loadingStatus;
  }
  @Mutation
  public MutationEmployeeSuggestionCode(code: string) {
    this.employeeSuggestionCode = code;
  }
  @Mutation
  public MutationDeleteEmployeeLoadingStatus(status: LoadingStatusType) {
    this.deleteEmployeeLoadingStatus = status;
  }

  @Mutation
  public MutationSetEmployeeFinanceChanelDetailListLoadingStatus(status: LoadingStatusType) {
    this.employeeFinanceChanelDetailListLoadingStatus = status;
  }

  @Mutation
  public MutationSetEmployeeFinanceChanelDetailList(
    employeeFinanceChanelDetailList: Array<EmployeeFinanceChanelDetailModel>
  ) {
    this.employeeFinanceChanelDetailList = employeeFinanceChanelDetailList;
  }

  @Mutation
  public MutationSetEmployeeStatementDetailListLoadingStatus(status: LoadingStatusType) {
    this.employeeStatementDetailListLoadingStatus = status;
  }

  @Mutation
  public MutationSetEmployeeStatementDetailList(employeeStatementList: Array<EmployeeStatementDetailModel>) {
    this.employeeStatementDetailList = employeeStatementList;
  }

  @Mutation
  public MutationSetemailOrBankAccountNumberDuplicated(emailOrBankAccountNumberDuplicated: any) {
    this.emailOrBankAccountNumberDuplicated = emailOrBankAccountNumberDuplicated;
  }

  @Mutation
  public MutationSetEmployeeTotalYearlyByEmployeeIdLoadingStatus(status: LoadingStatusType) {
    this.employeeTotalYearlyByEmployeeIdLoadingStatus = status;
  }

  @Mutation
  public MutationSetEmployeeTotalYearlyByEmployeeIdListLoadingStatus(status: LoadingStatusType) {
    this.employeeTotalYearlyByEmployeeIdListLoadingStatus = status;
  }

  @Mutation
  public MutationSetEmployeeTotalYearlyList(_employeeTotalYearlyList: Array<SalaryEmployeeTotalYearlyModel>) {
    _employeeTotalYearlyList.forEach((_employeeTotalYearly: SalaryEmployeeTotalYearlyModel, index: number) => {
      const employeeTotalYearlyIndex = this.employeeTotalYearlyList.findIndex(
        (x) => x.employeeId == _employeeTotalYearly.employeeId
      );
      if (employeeTotalYearlyIndex >= 0) {
        this.employeeTotalYearlyList[employeeTotalYearlyIndex].grossSalaryAmount =
          _employeeTotalYearly.grossSalaryAmount;
        this.employeeTotalYearlyList[employeeTotalYearlyIndex].taxCalculatedAmount =
          _employeeTotalYearly.taxCalculatedAmount;
        this.employeeTotalYearlyList[employeeTotalYearlyIndex].whtTotal = _employeeTotalYearly.whtTotal;
      } else {
        this.employeeTotalYearlyList.push(_employeeTotalYearly);
      }
    });
  }

  @Action
  public DoCreateEmployee(employeeTemplate: any) {
    if (this.createOrUpdateEmployeeLoadingStatus !== LoadingStatusType.Loading) {
      const validateEmployeeTemplate = ValidateEmployeeTemplate(employeeTemplate);
      let alertMessage: any = "";
      let alertType: TypeComponentNoti = TypeComponentNoti.Success;
      if (validateEmployeeTemplate) {
        this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.Loading);
        const input: any = {
          employee: ToEmployeeModel(employeeTemplate),
          image: ToEmployeeFileModel(employeeTemplate),
          fileEmployeeIDCard: ToFileEmployeeIDCardModel(employeeTemplate),
          fileEmployeeContract: ToFileEmployeeContractModel(employeeTemplate),
          confirmationEmailOrBankNumber: employeeTemplate.confirmationEmailOrBankNumber
            ? employeeTemplate.confirmationEmailOrBankNumber
            : false,
        };
        API.EmployeeService.DoCreateEmployee(input).then((resCreateEmployee) => {
          if (resCreateEmployee.data.responseCode.IsSuccess()) {
            this.context.commit("MutationEmployeeCreate", resCreateEmployee.data.employee);
            alertMessage = i18n.t("Create_Message_Success", {
              message:
                i18n.t("Employee") +
                " #" +
                employeeTemplate.code.value +
                " " +
                (i18n.locale == "en" ? employeeTemplate.firstNameTH.value : employeeTemplate.firstNameEN.value),
            });
            alertType = TypeComponentNoti.Success;
            this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.Success);
            this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.None);
          } else if (resCreateEmployee.data.exception.code == PeakPayrollExceptionCode.CodeDuplicated) {
            employeeTemplate.code.validateError = true;
            alertMessage = i18n.t("Exceptions_Notification.CodeDuplicated", { text: i18n.t("Employee") });
            alertType = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.None);
          } else if (
            resCreateEmployee.data.exception.code == PeakPayrollExceptionCode.EmailOrBankAccountNumberDuplicated
          ) {
            this.context.commit(
              "MutationSetemailOrBankAccountNumberDuplicated",
              resCreateEmployee.data.exception.content
            );
            this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.None);
          } else {
            alertMessage = GetExceptionsByExceptionCode(resCreateEmployee.data.exception);
            alertType = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.None);
          }

          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: alertType,
            },
            { root: true }
          );
        });
      } else {
        alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        alertType = TypeComponentNoti.Error;
      }
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: alertMessage,
          typeMessage: alertType,
        },
        { root: true }
      );
    }
  }

  @Action
  public DoUpdateEmployee(employeeTemplate: any) {
    if (this.createOrUpdateEmployeeLoadingStatus !== LoadingStatusType.Loading) {
      const validateEmployeeTemplate = ValidateEmployeeTemplate(employeeTemplate);
      let alertMessage: any = "";
      let alertType: TypeComponentNoti = TypeComponentNoti.Success;
      if (validateEmployeeTemplate) {
        this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.Loading);
        const employee = ToEmployeeModel(employeeTemplate);
        const inputUploadImage = {
          employeeId: employee.id,
          image: ToEmployeeFileModel(employeeTemplate),
          fileEmployeeIDCard: ToFileEmployeeIDCardModel(employeeTemplate),
          fileEmployeeContract: ToFileEmployeeContractModel(employeeTemplate),
        };
        API.EmployeeService.DoUpdateEmployee(employee).then((resUpdateEmployee) => {
          if (resUpdateEmployee.data.responseCode.IsSuccess()) {
            inputUploadImage.employeeId = employee.id;
            this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.None);
            API.EmployeeService.DoDeleteImageEmployee(employee.id).then((resDeleteImage) => {
              if (resDeleteImage.status.IsSuccess()) {
                API.EmployeeService.DoUploadImageEmployee(inputUploadImage).then((resUploadImage) => {
                  if (resUploadImage.status.IsSuccess()) {
                    this.context.commit("MutationEmployeeCreate", employee);
                    this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.None);
                    this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.Success);
                  }
                });
              }
            });
            alertMessage = i18n.t("Update_Message_Success", {
              message:
                i18n.t("Employee") +
                " #" +
                employee.code +
                " " +
                (i18n.locale == "en" ? employeeTemplate.firstNameTH.value : employeeTemplate.firstNameEN.value),
            });
            alertType = TypeComponentNoti.Success;
          } else if (resUpdateEmployee.data.exception.code == PeakPayrollExceptionCode.CodeDuplicated) {
            employeeTemplate.code.validateError = true;
            alertMessage = i18n.t("Exceptions_Notification.CodeDuplicated", { text: i18n.t("Employee") });
            alertType = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.None);
          } else if (resUpdateEmployee.data.exception.code == PeakPayrollExceptionCode.CodeIsEmpty) {
            employeeTemplate.code.validateError = true;
            alertMessage = i18n.t("Exceptions_Notification.CodeIsEmpty", { text: i18n.t("Employee") });
            alertType = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateDepartmentLoadingStatus", LoadingStatusType.None);
          } else {
            alertMessage = GetExceptionsByExceptionCode(resUpdateEmployee.data.exception);
            alertType = TypeComponentNoti.Error;
            this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.None);
          }

          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: alertType,
            },
            { root: true }
          );
        });
      } else {
        alertMessage = i18n.t("Please_Fill_In_Valid_Value");
        alertType = TypeComponentNoti.Error;
        this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.None);
      }
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: alertMessage,
          typeMessage: alertType,
        },
        { root: true }
      );
    }
  }

  @Action
  public DoGetEmployeeList() {
    if (this.employeeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetEmployeeList().then((resGetEmployeeList) => {
        if (resGetEmployeeList.status.IsSuccess()) {
          const employeeList = ConverToEmloyeeList(resGetEmployeeList.data.employeeList);
          this.context.commit("MutationEmployeeList", employeeList);
        }
        this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetEmployeeListByPasscode(merchantId: number) {
    if (this.employeeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetEmployeeListByPasscode(merchantId).then((resGetEmployeeList) => {
        if (resGetEmployeeList.status.IsSuccess()) {
          const employeeList = ConverToEmloyeeList(resGetEmployeeList.data.employeeList);
          this.context.commit("MutationEmployeeList", employeeList);
        }
        this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetEmployeeTable(employeeTableViewModel: EmployeeTableViewModel) {
    if (this.employeeTableLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationEmployeeTableLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetEmployeeTable(employeeTableViewModel).then((resGetEmployeeTable) => {
        if (resGetEmployeeTable.status.IsSuccess()) {
          const table = ConvertToEmployeeTable(resGetEmployeeTable.data.table);
          const input = {
            tableViewModel: employeeTableViewModel,
            table: table,
          };
          this.context.commit("MutationGetEmployeeTable", input);
        }
        this.context.commit("MutationEmployeeTableLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateEmployeeDeleted(employeeDetail: any) {
    if (this.createOrUpdateEmployeeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationDeleteEmployeeLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoUpdateEmployeeDeleted(employeeDetail.id).then((resUpdateEmployeeDeleted) => {
        let alertMessage: any = "";
        let typeMessage: TypeComponentNoti = TypeComponentNoti.success;
        if (resUpdateEmployeeDeleted.data.responseCode.IsSuccess()) {
          alertMessage = i18n.t("Remove_Message_Success", {
            message:
              i18n.t("Employee") +
              " #" +
              employeeDetail.code +
              " " +
              employeeDetail.firstNameLocale +
              " " +
              employeeDetail.lastNameLocale,
          });
          typeMessage = TypeComponentNoti.Success;
          this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.None);
          this.context.commit("MutationDeleteEmployeeLoadingStatus", LoadingStatusType.Success);
        } else {
          alertMessage = GetExceptionsByExceptionCode(resUpdateEmployeeDeleted.data.exception);
          typeMessage = TypeComponentNoti.Error;
          this.context.commit("MutationDeleteEmployeeLoadingStatus", LoadingStatusType.None);
        }
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: typeMessage,
          },
          { root: true }
        );
      });
    }
  }

  @Action
  public DoGetEmployeeDetail(employeeId: number) {
    if (this.employeeDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationEmployeeDetailLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetEmployeeDetail(employeeId).then((resGetEmployeeDetail) => {
        if (resGetEmployeeDetail.status.IsSuccess()) {
          const detail = ConvertToEmployeeDetail(resGetEmployeeDetail.data.detail);
          this.context.commit("MutationEmployeeDetail", detail);
        }
        this.context.commit("MutationEmployeeDetailLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetEmployeeHistoryDetail(employeeTableHistoryViewModel: EmployeeTableHistoryViewModel) {
    if (this.employeeHistoryDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationEmployeeHistoryDetailLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetEmployeeHistoryDetail(employeeTableHistoryViewModel).then((resGetEmployeeDetail) => {
        if (resGetEmployeeDetail.status.IsSuccess()) {
          const table = ConvertToEmployeeHistoryTable(resGetEmployeeDetail.data.historySalaryTable);
          const input = {
            tableViewModel: employeeTableHistoryViewModel,
            table: table,
          };
          this.context.commit("MutationEmployeeHistoryDetail", input);
        }
        this.context.commit("MutationEmployeeHistoryDetailLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetEmployeeSuggestionCode(departmentId: number) {
    if (this.employeeSuggestionCodeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetEmployeeSuggestionCodeLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetEmployeeSuggestionCode(departmentId).then((resGetEmployeeSuggestionCode) => {
        if (resGetEmployeeSuggestionCode.status.IsSuccess()) {
          this.context.commit("MutationEmployeeSuggestionCode", resGetEmployeeSuggestionCode.data.code);
        }
        this.context.commit("MutationSetEmployeeSuggestionCodeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoReloadEmployeeTable() {
    this.context.commit("MutationEmployeeTableLoadingStatus", LoadingStatusType.None);
  }

  @Action
  public DoEmployeeResign(input: any) {
    if (this.createOrUpdateEmployeeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.Loading);
      const _input = {
        employeeId: input.employeeId,
        isResign: input.isResign,
        employeeEndDate: input.isResign ? input.employeeEndDate : null,
        employeeResignReason: input.isResign ? input.employeeResignReason : 0,
        employeeResignNote: input.isResign ? input.employeeResignNote : "",
      };
      API.EmployeeService.DoUpdateEmployeeResign(_input).then((res) => {
        this.context.commit("MutationEmployeeLoadingStatus", LoadingStatusType.None);
        this.context.commit("MutationCreateOrUpdateEmployeeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetEmployeeFinanceChanelDetailList(employeeIdList: Array<number>) {
    if (this.employeeFinanceChanelDetailListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetEmployeeFinanceChanelDetailListLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetEmployeeFinanceChanelDetailList(employeeIdList).then((response) => {
        if (response.status.IsSuccess()) {
          const employeeFinanceChanelDetailList = ConvertToEmployeeFinanceChanelDetailList(response.data.employeeList);
          this.context.commit("MutationSetEmployeeFinanceChanelDetailList", employeeFinanceChanelDetailList);
        }
        this.context.commit("MutationSetEmployeeFinanceChanelDetailListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetEmployeeStatementDetailList(employeeIdList: Array<number>) {
    if (this.employeeStatementDetailListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetEmployeeStatementDetailListLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetEmployeeStatementDetailList(employeeIdList).then((response) => {
        if (response.status.IsSuccess()) {
          const employeeStatementDetailList = ConvertToEmployeeStatementDetailList(response.data.employeeList);
          this.context.commit("MutationSetEmployeeStatementDetailList", employeeStatementDetailList);
        }
        this.context.commit("MutationSetEmployeeStatementDetailListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetSalaryEmployeeTotalYearlyByEmployeeIdList(input: EmployeeTotalYearlyByEmployeeIdList) {
    if (this.employeeTotalYearlyByEmployeeIdListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetEmployeeTotalYearlyByEmployeeIdListLoadingStatus", LoadingStatusType.Loading);
      API.EmployeeService.DoGetSalaryEmployeeTotalYearlyByEmployeeIdList(input).then((response) => {
        if (response.status.IsSuccess()) {
          const employeeTotalYearlyList = ConvertToEmployeeTotalYearlyList(response.data.employeeTotalYearlyList);
          this.context.commit("MutationSetEmployeeTotalYearlyList", employeeTotalYearlyList);
        }
        this.context.commit("MutationSetEmployeeTotalYearlyByEmployeeIdListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetSalaryEmployeeTotalYearlyByEmployeeId(input: EmployeeTotalYearlyByEmployeeIdList) {
    this.context.commit("MutationSetEmployeeTotalYearlyByEmployeeIdLoadingStatus", LoadingStatusType.Loading);
    API.EmployeeService.DoGetSalaryEmployeeTotalYearlyByEmployeeIdList(input).then((response) => {
      if (response.status.IsSuccess()) {
        const employeeTotalYearlyList = ConvertToEmployeeTotalYearlyList(response.data.employeeTotalYearlyList);
        this.context.commit("MutationSetEmployeeTotalYearlyList", employeeTotalYearlyList);
      }
      this.context.commit("MutationSetEmployeeTotalYearlyByEmployeeIdLoadingStatus", LoadingStatusType.Success);
    });
  }
}
